import $ from 'jquery';

function cookieNotice() {
	const $cookieBar = $('.c-cookie-notice'),
				$close     = $cookieBar.find('.c-cookie-notice_close'),
				$accept    = $cookieBar.find('.c-cookie-notice_accept');

	if( !readCookie('cookie-notice') ) {
		$cookieBar.fadeIn('slow');
	}

	$close.click(function() {
		$cookieBar.fadeOut('fast');
	});

	$accept.click(function() {
		createCookie('cookie-notice', true, 30);
		$cookieBar.fadeOut('fast');
	})

	// COOKIES
	function createCookie(name, value, days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			var expires = "; expires=" + date.toGMTString();
		} else var expires = "";
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}
}

export { cookieNotice };